module.exports = __webpack_public_path__ + "static/img/jk1.175bc8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/jk1.png
// module id = 7p5c
// module chunks = 13